export const tabsTypes = {
  TERMS: 'TERMS',
  POLICY: 'POLICY',
};
